export class Helper {

  public static convertUrlToEmbedUrl(url: string): string {
    if (this.isYouTubeUrl(url)) {
      if (url.indexOf("embed") !== -1) {
        return url;
      } else {
        const rx = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
        const youtubeId: string = url.match(rx)[1];
        return "https://www.youtube.com/embed/" + youtubeId;
      }
    } else if (this.isVimeoVideo(url)) {
      const urlParts = url.split("/");
      const vimeoId = urlParts[urlParts.length - 1];
      return "https://player.vimeo.com/video/" + vimeoId;
    } else {
      return url;
    }
  }

  public static isYouTubeUrl(url: string): boolean {
    const p = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    if (url.match(p)) {
      return true;
    }
    return false;
  }

  public static isVimeoVideo(url: string): boolean {
    return url.indexOf("vimeo") !== -1;
  }

}